<app-page>
    <app-device-header [deviceId]="deviceId"></app-device-header>
    <app-device-events [deviceId]="deviceId"></app-device-events>
</app-page>
